import React, { useRef } from 'react';
import { useClientSize } from '@anton.bobrov/react-hooks';
import cx from 'classnames';
import styles from './index.module.scss.js';

const ArcAnimationMask = ({ className, style, maskId }) => {
  const ref = useRef(null);
  const { clientWidth, clientHeight } = useClientSize(ref);
  const radius = Math.sqrt(clientWidth * clientWidth + clientHeight * clientHeight) / 2;
  const length = Math.PI * radius * 2;
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      ref,
      className: cx(styles.box, className),
      style,
      width: clientWidth,
      height: clientHeight,
      viewBox: `0 0 ${clientWidth} ${clientHeight}`,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement("mask", { id: maskId }, /* @__PURE__ */ React.createElement(
      "circle",
      {
        className: styles.circle,
        r: radius,
        cx: clientWidth / 2,
        cy: clientHeight / 2,
        stroke: "rgba(255, 255, 255, 1)",
        strokeWidth: radius * 2,
        style: {
          strokeDasharray: `${length * 0.25}px ${length}px`,
          strokeDashoffset: 0
        }
      }
    ))
  );
};

export { ArcAnimationMask };
//# sourceMappingURL=index.js.map
